<template>
  <div class="select-multiple-buttons rounded">
    <label class="mt-1">{{ selectedCount }} selected </label>
    <v-divider v-if="!isSelectAll && !isMobile" class="mx-1" vertical />
    <v-btn
      @click="handleSelectAll"
      shrink
      text
      color="primary"
      v-if="!isSelectAll"
    >
      <div class="d-flex">
        Select All
        <v-icon class="ml-1">
          mdi-view-grid-outline
        </v-icon>
      </div>
    </v-btn>
    <v-divider class="mx-1" v-if="!isMobile" vertical />
    <v-btn @click="handleCancel" shrink text color="error">
      <div class="d-flex">
        Cancel
        <v-icon class="ml-1">
          mdi-close
        </v-icon>
      </div>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    selectedCount: Number,
    isSelectAll: Boolean
  },
  methods: {
    handleSelectAll() {
      this.$emit("selectAll");
    },
    handleCancel() {
      this.$emit("cancel");
    }
  }
};
</script>

<style lang="scss">
.candidates {
  .select-multiple-buttons {
    position: relative;
    top: -($base-footer-height + 20px);
    button {
      height: 35px !important;
      margin: 0px;
    }
    .v-divider--vertical {
      display: initial;
    }
    @media only screen and (max-width: $mobile-breakpoint - 1) {
      text-align: center;
      top: -($base-footer-height + 100px);
    }
  }
}
</style>
